module.exports = __webpack_public_path__ + "img/Weixin.838fda2b.png";